import {Component, ElementRef, OnInit} from '@angular/core';
import { UtilFns } from '../../utils/common';
import { ModalDialog } from '../../controls/common';

import {UnitOfWork} from '../../services/common';
import {RIFMContent} from '../../entities/EntityModels';

@Component({
    selector: 'user-acknowledgement',
    templateUrl: './user-acknowledgement.html',

})
export class UserAcknowledgementComponent extends ModalDialog<boolean> implements OnInit {
    public _isLoading = false;
    public _userAcknowledgementHTML: string;

    constructor(public elementRef: ElementRef, public _uow: UnitOfWork) {
        super(elementRef);
    }

    ngOnInit() {
        const params = { contentName: 'UserAcknowledgement' };
        return this._uow.fetchText('Misc/RIFMContentByName', params).then(fn => {
            if (fn != null && fn.length > 0) {
                this._userAcknowledgementHTML = fn;
            }
        });
    }

    fetchUserAcknowledgementContent(): Promise<boolean> {
        this._isLoading = true;

        const params = { contentName: 'UserAcknowledgementHTML' };
        return this._uow.fetchText('Misc/RIFMContentByName', params).then(fn => {
            if (fn != null && fn.length > 0) {
                this._userAcknowledgementHTML = fn;

                this._isLoading = false;

                return Promise.resolve(true);
            }
        });
    }

    onAccept(accept: boolean) {
        UtilFns.returnModal(this, accept);
    }

    onCancel(cancel: boolean) {
        UtilFns.returnModal(this, cancel);
    }

}
